import { LayoutGrid } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'

export function HeaderExploreLink() {
  const t = useTranslations('header')
  return (
    <Link
      href="/explore"
      aria-label={t('explore')}
      title={t('explore')}
      className="inline-flex size-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    >
      <LayoutGrid className="size-5" />
    </Link>
  )
}
